import axios from "axios";
import Cookies from "js-cookie";

const IMPERSONATION_COOKIE_KEY = 'impersonationToken';
const SOURCING_URL = process.env.REACT_APP_SOURCING_API_URL;

// Global axios interceptor - adds impersonation token to ALL requests
// config is used so we can modify the outgoing request (add the impersonation header) before Axios sends it.

const API_HOST = process.env.REACT_APP_API_HOST;

// The impersonation token is a bearer credential: only send it to our own APIs,
// never to third-party hosts (S3, AssemblyAI, etc.) that axios also calls.
const isFirstPartyApi = (url = "") =>
  (API_HOST && url.startsWith(API_HOST)) || (SOURCING_URL && url.startsWith(SOURCING_URL));

axios.interceptors.request.use((config) => {
  const token = Cookies.get(IMPERSONATION_COOKIE_KEY);
  if (token && isFirstPartyApi(config.url)) {
    config.headers['X-Impersonation-Token'] = token;
  }

  // Sourcing API is authenticated with the same Cognito access token as GenieHire.
  // Scoped to sourcing-bound requests only — GenieHire call sites already set the
  // Authorization header themselves.
  if (SOURCING_URL && config.url && config.url.startsWith(SOURCING_URL)) {
    const accessToken = Cookies.get('accessToken');
    if (accessToken && !config.headers['Authorization']) {
      config.headers['Authorization'] = `Bearer ${accessToken}`;
    }
  }

  return config;
});
